(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('receiptApp')
        .constant('CONST_RECEIPT', {
        	'STATE_RECEIPT': "receipt",
        	'STATE_PROPOSAL': "receipt.proposal",
        	'STATE_INDIVIDUAL': "receipt.proposal.individual",
        	'STATE_CORPORATION': "receipt.proposal.corporation",
        	'STATE_CONTEST': "receipt.proposal.contest",
        	'STATE_POLICY': "receipt.policy",
        	'TRANSACTION_TYPE_PROPOSAL': "100",
        	'TRANSACTION_TYPE_POLICY': "200",
        	'CUSTOMER_TYPE_INDIVIDUAL': "P",
        	'CUSTOMER_TYPE_CORPORATION': "C",
        	'PROPOSAL_PAGE_TITLE': "HỒ SƠ MỚI",
        	'PROPOSAL_INDIVIDUAL_PAGE_TITLE': "Thu phí - Hồ sơ - Cá nhân",
        	'PROPOSAL_CORPORATION_PAGE_TITLE': "Thu phí - Hồ sơ - Doanh nghiệp",
        	'POLICY_PAGE_TITLE': "THU PHÍ & HOÀN TRẢ",
        	'CONTEST_PAYMENT_PAGE_TILE': "CONTEST PAYMENT",
        	'REGEX': "^[0-9a-zA-Z _ÀÁẠẢÃÂẤẦẪẬẨĂẮẰẲẴẶÈÉẸẺẼÊẾỀỂỄỆỌÕÒÓỎƠỚỜỞỠỢỐỒỔỖỘÔỈỊÌÍĨỲỴÝỶỸÙÚỤỦŨỨỪỬỮỰƯĐàáạảãâấầẩẫậăắằẳẵặèéẹẻẽêếềểễệìíĩỉịỳỵýỷỹọỏòóõơớờởỡợốồổỗộôùúũụủưứừửữựđ]+$",
        	'STATE_POLICY_REVERSAL': "receipt.policyreversal",
        	'TRANSACTION_TYPE_POLICY_REVERSAL': "1700",
        	'LST_REQUEST_TYPE': [ {
        		code : 'PS-07',
        		name : 'Khôi phục hiệu lực hợp đồng'
        	} ],
        	'LST_REQUEST_SUB_TYPE': [ {
        		code : 'PS-SUB-136',
        		name : 'Khôi phục hiệu lực hợp đồng (HD mất hiệu lực từ ngày 61 đến ngày D70)'
        	} ]
        });
})();
